import { useLazyQuery } from '@apollo/client/react'
import { useCallback, useEffect } from 'react'
import queries from '../queries'

export default function useLanguages() {
  const [loadLanguages, { data, loading, error }] = useLazyQuery(queries.standardsLanguages(), {
    errorPolicy: 'all',
  })

  useEffect(() => {
    if (!data && !loading && !error) {
      loadLanguages()
    }
  }, [data, error, loadLanguages, loading])

  const getLanguageProps = useCallback(
    (propName, key, keyValues = []) => {
      if (!data?.standardsLanguages) {
        return null
      }

      const items = []
      const standardsLanguages = data?.standardsLanguages
      if (Array.isArray(standardsLanguages) && Array.isArray(keyValues)) {
        if (keyValues) {
          keyValues.forEach((val) => {
            const item = standardsLanguages.find((el) => el[key] === val)?.[propName]
            if (item) {
              items.push(item)
            }
          })
        }
      }
      return items
    },
    [data]
  )

  const getLanguagesFromCodes = useCallback((codes) => getLanguageProps('language', 'code', codes), [getLanguageProps])

  const getCodesFromLanguages = useCallback(
    (languages) => getLanguageProps('code', 'language', languages),
    [getLanguageProps]
  )

  return { data, loading, error, getLanguagesFromCodes, getCodesFromLanguages }
}
